export interface CryptoSession {
  sessionId: string;
  aesKey: CryptoKey;
  expiresAt: number; // Unix ms
}

let _session: CryptoSession | null = null;

export const getSession = (): CryptoSession | null => _session;
export const setSession = (s: CryptoSession): void => { _session = s; };
export const clearSession = (): void => { _session = null; };

// Returns false within the last 5 min before expiry so we can proactively refresh.
export const isSessionValid = (): boolean => {
  if (!_session) return false;
  const BUFFER_MS = 5 * 60 * 1000;
  return Date.now() < _session.expiresAt - BUFFER_MS;
};
